import {
  CreateClientDto,
  ListClientParamDto,
} from "../entities/dto/client.dto";
import { Client } from "../entities/interfaces/client";
import { PageParamsAsString } from "../entities/interfaces/misc";
import Api, { ApiResponse } from "../utils/axios";

export const list = async (
  params: ListClientParamDto & PageParamsAsString,
  skipStoreId: boolean = false
): Promise<ApiResponse<Client[]>> => {
  return await Api.get(`/customers?${new URLSearchParams(params)}` as any);
};

export const create = async (
  createClientDto: CreateClientDto
): Promise<ApiResponse<Client>> => {
  return await Api.post("/customers", createClientDto);
};

export const update = async (
  id: string,
  updateClientDto: CreateClientDto
): Promise<ApiResponse<Client>> => {
  return await Api.patch(`/customers/${id}`, updateClientDto);
};

const ClientService = { list, create, update };
export default ClientService;
